"use strict";
// Copyright © Veeam Software Group GmbH
Object.defineProperty(exports, "__esModule", { value: true });
exports.ADVANCED_FILTER_DEFAULT_TEXTS = void 0;
exports.ADVANCED_FILTER_DEFAULT_TEXTS = {
    all: 'All',
    none: 'None',
    cancel: 'Cancel',
    apply: 'Apply',
    captionAll: 'All',
    captionNone: 'None',
    captionOf: 'of'
};
//# sourceMappingURL=AdvancedFilterDefaultTexts.js.map